<template>
    <div>
        <v-autocomplete
                v-model="model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                :full-width="true"
                cache-items
                clearable
                :rules="rules"
                item-value="id"
                item-text="name"
                no-filter
                :multiple="multi"
                color="primary"
                :return-object="returnObject"
                placeholder="Start typing to Search"
                prepend-icon="mdi-database-search"
        >
            <template
                    slot="selection"
                    slot-scope="data"
            >
                <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi"
                        @input="remove(data.item.id)"
                >
                    {{ data.item.name }}
                </v-chip>
            </template>
            <template
                    slot="item"
                    slot-scope="data"
            >
                <v-list-tile-content>
                    <v-list-tile-title
                            v-html="data.item.name"></v-list-tile-title>
                </v-list-tile-content>
            </template>
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
    </div>
</template>

<script>
    export default {
        name: "choose-area-multi",
        props: {
            label: {},
            value: {},
            url: {
                type: String,
                default() {
                    return this.api.ACTIONS.AREA
                }
            },
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            },
            multi: {
                type: Boolean,
                default: true
            },
            returnObject: {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default: () => []
            }
        },
        mounted() {
            if (this.returnObject && !!this.value) {
                this.data = this.value instanceof Array ? this.value : [this.value];
            }
            this.getData();
        },
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        watch: {
            search() {
                this.getData();
            },
            initialSearchParams() {
                this.getData();
            },
            model(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            remove(id) {
                this.model = this.model.filter(item => item !== id);
            },
            getData() {
                const val = this.search;
                this.loading = true;
                const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val || '');
                this.axios.get(this.url, {params})
                    .then(res => {
                        const {data} = res.data.data;
                        this.data = data.map(item => ({
                            text: item.name,
                            ...item
                        }));
                    })
                    .catch(err => console.log(err))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>
